import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import "./closedDisputes.css";
import Header from "../../../COMPONENTS/header/Header";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../../CONTEXT/AuthProvider";
import "react-datepicker/dist/react-datepicker.css";

function ClosedDisputes() {
  const [closedDisputes, setClosedDisputes] = useState([]);
  const navigate = useNavigate();
  const { auth } = useContext(AuthContext);
  const subscribername = auth.subscriberName;
  const staff = auth.staff;
  const accessToken = auth.accessToken;
  const digitalLendor = auth.digitalLendor;

  useEffect(() => {
    if (staff === "Yes" || subscribername === "BANK OF TANZANIA") {
      axios
        .get("/api/closed-disputes", {
          headers: {
            'Authorization': 'Bearer ' + accessToken
          }
        })
        .then((response) => {
          // Filter the data on the client-side based on the subscriberName
          const dataResponse = response.data.map((subscribers, index) => ({
            ...subscribers,
            rowNumber: index + 1,
          }));
          setClosedDisputes(dataResponse);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      axios
        .get("/api/closed-disputes", {
          headers: {
            'Authorization': 'Bearer ' + accessToken
          }
        })
        .then((response) => {
          // Filter the data on the client-side based on the subscriberName
          const dataResponse = response.data
            .filter(
              (subscribers) => (subscribers["Subscriber Name"] === subscribername || subscribers["Subscriber Name"] === digitalLendor)
            )
            .map((subscribers, index) => ({
              ...subscribers,
              rowNumber: index + 1,
            }));
          setClosedDisputes(dataResponse);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [subscribername, staff, accessToken, digitalLendor]);

  const handleView = (
    contractCode,
    subjectName,
    created,
    resolved,
    status,
    subscriberName,
    age,
    ageDefinition,
    comments
  ) => {
    const closedDisputeDetails = {
      contractCode,
      subjectName,
      created,
      resolved,
      status,
      subscriberName,
      age,
      ageDefinition,
      comments,
    };
    navigate("/ViewClosedDisputes", { state: { closedDisputeDetails } });
  };

  const columns = [
    {
      field: "rowNumber",
      headerName: "#",
      flex: 0.3,
    },
    {
      field: "Contract Code",
      headerName: "Contract Code",
      flex: 1,
    },
    {
      field: "Subject Name",
      headerName: "Subject Name",
      flex: 1.3,
    },
    {
      field: "Created",
      headerName: "Created",
      flex: 0.6,
    },
    {
      field: "Resolved",
      headerName: "Resolved",
      flex: 0.6,
    },
    {
      field: "Status",
      headerName: "Status",
      flex: 0.6,
      renderCell: (params) => {
        const activeStatus = params.value;
        return <div className="closedCell">{activeStatus}</div>;
      },
    },
    {
      field: "Subscriber Name",
      headerName: "Subscriber Name",
      flex: 1.4,
    },
    {
      field: "Age Definition",
      headerName: "Due Time",
      flex: 0.7,
      renderCell: (params) => {
        const ageDefinition = params.value;
        const isExpired = ageDefinition.includes("Late");
        const cellClassName = isExpired ? "red-closed-cell" : "green-closed-cell";
        return <div className={cellClassName}>{ageDefinition}</div>;
      },
    },
    {
      field: "action",
      headerName: "Action",
      flex: 0.6,
      renderCell: (params) => {
        return (
          <>
            <button
              className="viewClosedDisputesButton"
              onClick={() =>
                handleView(
                  params.row["Contract Code"],
                  params.row["Subject Name"],
                  params.row.Created,
                  params.row.Resolved,
                  params.row.Status,
                  params.row["Subscriber Name"],
                  params.row.Age,
                  params.row["Age Definition"],
                  params.row.Comments
                )
              }
            >
              View
            </button>
          </>
        );
      },
    },
  ];
  return (
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        <Box m="8px">
          <Box m="8px">
            <Header
              title="CLOSED DISPUTES"
              subtitle="View all closed disputes in the system"
            />
            <Box
              m="40px 0 0 0"
              height="100vh"
              sx={{
                "& .MuiDataGrid-root": {
                  border: "none",
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "none",
                },
                "& .name-column--cell": {
                  color: "#2e7c67",
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#bbbbbb",
                  borderBottom: "none",
                },
                "& .MuiDataGrid-virtualScroller": {
                  backgroundColor: "#f2f0f0",
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "none",
                  backgroundColor: "#a4a9fc",
                },
                "& .MuiCheckbox-root": {
                  color: `${"#1e5245"} !important`,
                },
                "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                  color: `${"#525252"} !important`,
                },
              }}
            >
              <DataGrid
                rows={closedDisputes}
                columns={columns}
                components={{ Toolbar: GridToolbar }}
              />
            </Box>
          </Box>
        </Box>
      </main>
    </div>
  );
}

export default ClosedDisputes;
